import defineComponent from 'flight';

function CartOverviewUI() {

    this.defaultAttrs({
        emptyCartLabel: '[data-empty-cart-label]',
        merchantPreOrders: '[data-view-cart-merchant]',
        cartItems: '[data-view-cart-item]'
    });

    this._checkIfCartIsEmpty = function () {
        if (this.select('merchantPreOrders').length === 0 || this.select('cartItems').length === 0) {
            this.select('emptyCartLabel').removeClass('hidden');

            if (document.width < 400) {
                window.scrollTo(0, 1);
            }
        }
    };

    this.after('initialize', function () {
        this.on(document, 'ui:cart-after-item-remove', this._checkIfCartIsEmpty);
        this.on(document, 'ui:cart:on-items-remove', this._checkIfCartIsEmpty);
    });
}

module.exports = defineComponent.component(CartOverviewUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/cart/cart-overview-ui.js